var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-wrapper"},[_c('Calendar',{attrs:{"first-instance":_vm.firstInstance,"last-instance":_vm.lastInstance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }